
Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.Card = void 0;

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _Card = require('./Card.styled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Card = function Card(props) {
  var children = props.children;
  return _react.default.createElement(_Card.StyledCard, null, children);
};
/**
 * Definition of default values for component props
 */

exports.Card = Card;
Card.defaultProps = {
  children: undefined
};
Card.propTypes = {
  children: _propTypes.default.node
};
